<template>
    <div id="nav-bar">
        <NavButtons
            class="nav-bar-item-container-desktop"
            @click="isDropDownVisible = false"
        />
        <transition name="drop-down">
            <NavButtons
                v-show="isDropDownVisible"
                class="nav-bar-item-container-mobile"
                @click="isDropDownVisible = false"
            />
        </transition>
        <DropDownButton
            id="drop-down-button"
            :is-open="isDropDownVisible"
            @click="onDropDownButtonClick"
        />
    </div>
</template>

<script lang="ts">
import {
    defineComponent,
    ref,
    onMounted,
    onBeforeUnmount,
    watchEffect,
} from "vue";
import NavButtons from "@/components/navigation/NavButtons.vue";
import DropDownButton from "@/components/navigation/DropDownButton.vue";

export default defineComponent({
    components: { NavButtons, DropDownButton },
    setup() {
        const isDropDownVisible = ref(false);

        watchEffect(() => {
            if (isDropDownVisible.value) {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });

                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "";
            }
        });

        onMounted(() => {
            onWindowResize();
            window.addEventListener("resize", onWindowResize);
        });

        onBeforeUnmount(() => {
            window.removeEventListener("resize", onWindowResize);
        });

        function onWindowResize() {
            if (window.innerWidth > 760) {
                isDropDownVisible.value = false;
            }
        }

        function onDropDownButtonClick() {
            isDropDownVisible.value = !isDropDownVisible.value;
        }

        return {
            onDropDownButtonClick,
            isDropDownVisible,
        };
    },
});
</script>

<style lang="scss">
@use "@/assets/global";

#nav-bar {
    width: 100%;
    min-height: 100px;

    @media (max-width: global.$mobile-width) {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }

    .nav-bar-item-container-desktop {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        padding-top: 10px;
        padding-right: 50px;

        @media (max-width: global.$mobile-width) {
            display: none;
        }
    }

    .nav-bar-item-container-mobile {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0px;

        position: fixed;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;

        pointer-events: auto;

        background-color: global.$background-color;
        @media (prefers-color-scheme: dark) {
            background-color: global.$dark-theme-background-color;
        }

        z-index: 1;

        @supports (backdrop-filter: blur(20px)) {
            background-color: unset;
            backdrop-filter: blur(20px);
        }

        @media not all and (max-width: global.$mobile-width) {
            display: none;
        }

        &.drop-down-enter-active,
        &.drop-down-leave-active {
            transition-property: background-color, backdrop-filter, opacity;
            @media (prefers-color-scheme: dark) {
                transition-property: dark-thme-background-color, backdrop-filter,
                    opacity;
            }
            transition-duration: 300ms;
        }

        &.drop-down-enter-from,
        &.drop-down-leave-to {
            background-color: unset;
            backdrop-filter: unset;
            opacity: 0;
        }
    }

    #drop-down-button {
        background-color: transparent;
        border: none;
        margin-right: 30px;
        margin-top: 30px;
        outline: none;

        @media not all and (max-width: global.$mobile-width) {
            display: none;
        }

        img {
            width: 50px;
            height: 50px;
        }
    }
}
</style>
